import { FC } from "react";
import { countryCodesByAlpha3 } from "assets/country-codes/country-codes";
import { capitalizeTitle } from "utils";

/* components */
import AllowedDocument from "models/documents/allowed-document";
import LocalImages from "assets/images/local-images";
import Flag from "features/shared/components/picker/components/Flag";

/* styles */
import StyledDocumentSelectorOption from "./styles/StyledDocumentSelectorOption.styled";
import { ButtonTitle } from "features/shared/styles/typography/ButtonTitle.styled";
import FlagRoundFrame from "features/questions-page/components/have-document-questions/styles/FlagRoundFrame.styled";

const getImageForDocument = (doc: AllowedDocument) => {
  if (doc.country === "EURO")
    return (
      <img
        width="36"
        height="36"
        src={LocalImages.shared.images.icons.docEuro}
        alt="document icon"
      />
    );

  const code = doc.country ? countryCodesByAlpha3[doc.country] : null;

  if (!code) {
    return (
      <img
        src={LocalImages.shared.images.icons.docSelectorPassport}
        alt="document icon"
      />
    );
  } else
    return (
      <FlagRoundFrame>
        <Flag codeAlpha2={code.alpha2} direction={"ltr"} />
      </FlagRoundFrame>
    );
};

interface DocumentSelectorOptionProps {
  doc: AllowedDocument;
  isSelected: boolean;
  onClick: () => void;
}

const DocumentSelectorOption: FC<DocumentSelectorOptionProps> = ({
  doc,
  isSelected,
  onClick,
}) => {
  return (
    <StyledDocumentSelectorOption selected={isSelected} onClick={onClick}>
      {getImageForDocument(doc)}
      <ButtonTitle>{capitalizeTitle(doc.title)}</ButtonTitle>
    </StyledDocumentSelectorOption>
  );
};

export default DocumentSelectorOption;
